module.exports = __webpack_public_path__ + "img/pencil-portrait_en.bad4795.jpg";